import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Handle, Position } from "@xyflow/react";
export const WorkspaceNode = memo(({ data, selected }) => {
    const nodeData = data;
    const metadata = nodeData.metadata;
    return (_jsxs("div", { className: `flow-node-workspace ${selected ? "selected" : ""}`, style: {
            padding: "16px",
            border: `2px solid ${selected ? "var(--flow-node-text, #000)" : "var(--flow-node-border, #e5e5e5)"}`,
            borderRadius: "8px",
            background: "var(--flow-node-bg, #fff)",
            minWidth: "200px",
            boxShadow: "0 1px 4px 0 rgba(0,0,0,0.07)",
        }, children: [_jsx(Handle, { type: "target", position: Position.Top, style: { background: "var(--flow-node-border, #e5e5e5)" } }), _jsxs("div", { style: { marginBottom: "8px" }, children: [_jsx("div", { style: {
                            fontSize: "16px",
                            fontWeight: 600,
                            color: "var(--flow-node-text, #000)",
                            marginBottom: "4px",
                        }, children: metadata.name }), _jsxs("div", { style: {
                            fontSize: "12px",
                            color: "var(--flow-node-text-secondary, #444)",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                        }, children: [_jsx("span", { style: {
                                    padding: "2px 6px",
                                    borderRadius: "4px",
                                    background: metadata.isOwner
                                        ? "var(--flow-node-text, #000)"
                                        : "var(--flow-accent, #bdbdbd)",
                                    color: metadata.isOwner ? "#fff" : "var(--flow-node-text, #000)",
                                    fontSize: "11px",
                                    fontWeight: 500,
                                }, children: metadata.role }), metadata.memberCount !== undefined && (_jsxs("span", { children: [metadata.memberCount, " members"] }))] })] }), _jsx(Handle, { type: "source", position: Position.Bottom, style: { background: "var(--flow-node-border, #e5e5e5)" } })] }));
});
WorkspaceNode.displayName = "WorkspaceNode";
